// extracted by mini-css-extract-plugin
module.exports = {"countryRow":"JCTtdNGK","countryNameWrapper":"uqEtyrGA","countryName":"xleG2rEC"};